<template>
  <div class="tm">
    <div class="em">
      <div class="admin-title">
        <i class="el-icon-s-home"></i>
        <router-link style="text-decoration: none;" to="/admin"><span  style="color: #f0e4e4;">首页</span></router-link>
      </div>
      <el-menu :default-active="$route.path" class="el-m" text-color="#f0e4e4" background-color="#545c64" action-text-color="#33a881">
        <template v-for="menuItem in menuList">
          <div :key="menuItem.id" v-if="menuItem.children.length > 0">
            <el-submenu :index="menuItem.id.toString()" :class="{active: isActive(menuItem)}">
              <template slot="title">
                <i :class="menuItem.icon"></i>
                <span slot="title">{{ menuItem.title }}</span>
              </template>
              <el-menu-item v-for="subMenuItem in menuItem.children" :key="subMenuItem.id" :index="subMenuItem.uri">
                <!-- <i :class="subMenuItem.icon"></i>
                <span @click="handleClick(subMenuItem.uri)">{{ subMenuItem.title }}</span> -->
                <li @click="handleClick(subMenuItem.uri)"><i :class="subMenuItem.icon"></i>{{ subMenuItem.title }}</li>
              </el-menu-item>
            </el-submenu>
          </div>
          <el-menu-item v-else key="menuItem.id" :index="menuItem.uri" :class="{active: isActive(menuItem)}">
            <router-link :to="{ path: menuItem.uri }">{{ menuItem.title }}</router-link>
            <i :class="menuItem.icon"></i>
            <span slot="title">{{ menuItem.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="r_v">
      <div class="v-header">
        <router-link class="router-link-active" to="/admin"><span>首页/</span></router-link>
        <span v-for="(crumb, index) in crumbs" :key="index">
          <router-link :to="crumb.path">{{ crumb.name }}</router-link>
          <!-- <span v-if="index < crumbs.length - 1"> / </span> -->
        </span>
        <el-dropdown class="el-d">
          <i class="el-icon-setting">设置</i>
          <el-dropdown-menu slot="dropdown">
            <div class="dropdown-content">
              <el-dropdown-item><router-link class="router-link-active" to="/admin">首页</router-link></el-dropdown-item>
              <el-dropdown-item><el-button type="text" @click="getUser" style="color: black;">信息修改</el-button></el-dropdown-item>
              <el-dropdown-item><el-button type="text" @click="logout" style="color: black;">退出</el-button></el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="con-view">
        <router-view></router-view>
      </div>
    </div>
    <!-- 编辑用户表单 -->
    <el-dialog title="编辑用户" :visible.sync="editDialogVisible" @close="editClose">
      <el-form ref="editForm" :model="editForm" label-width="120px">
          <el-form-item prop="id" :formatter="formatId">
              <el-input v-model="editForm.id" style="display: none;"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="username" :rules="{
              required: true, message: '该项不能为空', trigger: 'blur'
          }">
              <el-input v-model="editForm.username"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" :rules="{
              required: true, message: '该项不能为空', trigger: 'blur'
          }">
              <el-input v-model="editForm.password" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item label="头像" prop="icon">
              <el-input v-model="editForm.icon"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
              <el-input v-model="editForm.email"></el-input>
          </el-form-item>
          <el-form-item label="昵称" prop="nick_name">
              <el-input v-model="editForm.nick_name"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="note">
              <el-input v-model="editForm.note"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="doEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from '@/axiosInstance';
import Cookies from 'js-cookie'
  export default {
    name: "Hone",
    data() {
        return {
            menuActive: "",
            crumbs: [],
            menuList: "",
            editForm: {
              id: '',
              username: '',
              password: '',
              icon: '',
              email: '',
              nick_name: '',
              note: '',
              status: '',
            },
            editDialogVisible: false
          };
    },
    // adminPermission
    created() {
      // 路由监听
      this.$router.afterEach(route => {
        this.crumbs = this.updateCrumbs(route)
      });
      this.getMenu();
      this.MenuRouters();
    },
    mounted() {
      this.$nextTick(function() {
            this.$on('childmethods', function() {
                this.getMenu()
            });
          });
    },
    methods: {
        // 权限列表
        getMenu() {
            try {
                axios.get(`/adminUser/adminUserACPermission`).then(res => {
                    if (res.status === 200) {
                        if (res.data["code"] === 0) {
                            const data = JSON.parse(res.data["data"]);
                            const treeData = this.convertToTree(data);
                            this.menuList = this.convertToMenu(treeData);
                        } else if(res.data["code"] === 6) {
                            this.$message.error("权限不足")
                        } else {
                          this.$message.error("请求失败，请稍后尝试")
                        }
                      } else {
                        this.$message.error("请求失败，请稍后尝试")
                      }
                }).catch(() => {
                  this.$message.error("请求失败，请稍后尝试")
                })
            }catch (error) {
                this.$message.error("请求失败，请稍后尝试");
            }
        },
        // 菜单数据处理
        convertToTree(data) {
            const map = {};
            const result = [];
            data.forEach(item => {
                item.children = [];
                map[item.pk] = item;
                if (item.fields.type === 0) {
                    result.push(item);
                }
                else {
                    const parent = map[item.fields.pid];
                    if (parent) {
                        parent.children.push(item);
                    }
                }
            });
            return result;
        },
        // 将树形结构转换为侧边导航栏数据
        convertToMenu(treeData) {
            const menuList = [];
            treeData.forEach(item => {
                const menuItem = {
                    id: item.pk,
                    title: item.fields.title,
                    icon: item.fields.icon,
                    children: [],
                };
                item.children.forEach(child => {
                    if (child.fields.type === 1 && child.fields.name) {
                        menuItem.children.push({
                            id: child.pk,
                            title: child.fields.title,
                            uri: child.fields.uri,
                            icon: child.fields.icon
                        });
                    }
                });
                if (menuItem.children.length) {
                    // 构建侧边栏数据
                    menuList.push(menuItem);
                }
            });
            return menuList;
        },
        // 动态路由
        async MenuRouters() {
          let menu_routers = []
          const res = await axios.get(`/adminUser/adminUserACPermission`)
          if (res.status === 200 && res.data["code"] === 0) {
            const treeData = this.convertToTree(JSON.parse(res.data["data"]))
            treeData.forEach(item => {
              item.children.forEach(child => {
                if (child.fields.type === 1 && child.fields.uri) {
                  const MenuRouter = {
                    path: child.fields.uri,
                    name: child.fields.name,
                    component: () => import(`@/views/${child.fields.name}.vue`),
                    meta: {
                      title: child.fields.title
                    }
                  }
                  // menu_routers.push(child.fields.uri)
                  menu_routers.push(MenuRouter)
                }
              })
            })
          }
          return menu_routers;
        },
        isActive(menuItem) {
            // 判断当前路由的路径是否以指定的字符串开头
            if (menuItem.uri && this.$route.path.startsWith(menuItem.uri)) {
                return true;
            }
            if (menuItem.children) {
                return menuItem.children.some(child => this.isActive(child));
            }
            return false;
        },
        handleClick(path) {
          this.$router.push({path})
        },
        // 更新面包屑
        updateCrumbs(route) {
          let crumbs = [];
          let matched = route.matched;
          if (!matched) {
            return crumbs
          }
          matched.forEach((match, index) => {
          crumbs.push({
            name: match.meta.title,
            path: match.path
            });
          });
          return crumbs;
        },
        // 退出
        logout() {
          Cookies.remove('token')
          this.$router.push('/login')
        },
        getUser() {
          this.editDialogVisible = true
          axios.get(`/adminUser/adminUserView`).then(res => {
            if (res.status === 200) {
              if (res.data["code"] === 0){
                const data = JSON.parse(res.data["data"]["data"])
                data.forEach(item => {
                    Object.assign(this.editForm, item.fields)
                })
                this.$set(this.editForm, 'id', data[0].pk)
              } else if (res.data["code"] === 6) {
                this.$message.error("权限不足")
              } else {
                this.$message.error("请求失败，请稍后重试")
              }
            } else {
              this.$message.error("请求失败，请稍后重试")
            }
          }).catch(() => {
            this.$message.error("请求失败，请稍后重试")
          })
        },
        doEdit() {
          axios.put(`/adminUser/adminUserView`, this.editForm).then(res => {
            if (res.status === 200){
              if (res.data["code"] === 0) {
                this.$message.success("修改成功")
                this.editDialogVisible = false
              }else if(res.data["code"] === 6){
                this.$message.error("权限不足，无法修改，请联系管理员")
              }else {
                this.$message.error("操作失败，请稍后重试")
              }
            }else {
              this.$message.error("操作失败，请稍后重试")
            }
          }).catch(() => {
            this.$message.error("操作失败，请稍后重试")
          })
        },
        editClose() {
          this.editDialogVisible = false
          this.editForm = {}
        },
        formatId(row, column, cellValue, index) {
            return ''
        },
    },
};
</script>

<style>
* {
  box-sizing: border-box;
}
.tm {
  display: flex;
  height: auto;
  width: auto;
}

/* 面包屑 */
.v-header {
  margin-left: 15rem;
  margin-top: 15px;
  height: 30px;
  font-size: 17px;
  background-color: rgb(255, 255, 255);
}
.el-icon-setting {
  font-size: 13px;
}
.el-d {
  padding-right: 10px;
  float: right;
}

/* 侧边导航栏 */
/* .em {
  height: auto;
  min-height: 100vh;
  left: 0;
  bottom: 0;
  width: 220px;
  background-color: #34373b;
  display: inline-block;
} */

.em {
  position: fixed;
  top: 0;
  left: 0;
  width: 222px;
  height: 100vh;
  background-color: #34373b;
  z-index: 999;
  overflow-y: auto;
}
.con-view {
  margin-left: 221px;
}

.admin-title {
  margin-top: 0;
  text-align: center; 
  font-size: 22px; 
  height: 55px; 
  background-color: #4d9cc4;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-m {
  width: 223px;
  text-align: left;
  font-family: 'Times New Roman', Times, serif;
}
.el-m .el-submenu {
  font-size: 16px;
}
.el-m .el-menu-item {
  font-size: 15px;
}
/* 子组件展示位置 */
.r_v {
  /* margin-left: 220px; 留出导航栏的宽度 */
  margin-right: 0%;
  flex: 1;
}
.admin-title:hover {
  background-color: rgb(75, 190, 152);
}
.router-link-active {
  position: relative;
  text-decoration: none;
  color: #333; 
}
.dropdown-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>